import React from "react";

import "./index.scss";

const ButtonIcon = ({
  className = "",
  children,
  size = "medium",
  ...remainingProps
}: React.ButtonHTMLAttributes<HTMLButtonElement> & {
  size?: "medium" | "large";
}) => {
  return (
    <button
      className={`component button-icon ${className} size-${size}`}
      type="button"
      {...remainingProps}
    >
      {children}
    </button>
  );
};

export default ButtonIcon;
